import React from 'react'
import { Col } from 'react-bootstrap'

import Field from '../../../../../../Field'
import Select from '../../../../../../Select'
import { IFilterType } from '../../../../../types'

const MultivalueType = (props: IFilterType): React.ReactElement => {
  const { filter, index } = props

  const {
    colWidth,
    name = '',
    hideLabel,
    label,
    options,
    placeholder,
  } = filter || {}

  return (
    <Col md={colWidth ? colWidth : 6} key={index}>
      <Field name={name} label={!hideLabel && label && `${label}`}>
        <Select
          direct
          options={options}
          isMulti
          customPlaceholder={
            placeholder || i18n.t('select_options', 'Wählen...')
          }
        />
      </Field>
    </Col>
  )
}

export default MultivalueType
